module.exports = __webpack_public_path__ + "img/img1.a5f65e5f.jpg";